// Equivalent central codes for the existing unlock permission and its V2 name.
// This normalizes assigned grants; it never creates a grant for an unassigned user.
export const normalizeActionCode = (value?: string | null) => {
    const code=(value || '').trim().toLowerCase();
    return code==='bskt_diem_mokhoa'?'bskt_diem_duyet':code;
};
